module.exports = __webpack_public_path__ + "static/media/memos_note12.17d86c48.jpg";